import appContent from './content';
import HomePage from './content-types/HomePage';

let {
  ArticlesIndexer,
  ArticleBySlug,
  FranchiseIndexer,
  StudioSlideshowImageIndexer,
  ProfileIndexer,
  HistoryIndexer,
  CityGalleryImageIndexer,
} = appContent.classes;

export default async function (view, params, repo) {
  let content = {};
  switch (view) {
    case 'home':
      content.franchises = await repo.fetchContentAtPath(FranchiseIndexer.indexFileName, FranchiseIndexer) || {};
      content.studioSlides = await repo.fetchContentAtPath(StudioSlideshowImageIndexer.indexFileName, StudioSlideshowImageIndexer) || {};
      content.profiles = await repo.fetchContentAtPath(ProfileIndexer.indexFileName, ProfileIndexer) || {};
      content.historySlides = await repo.fetchContentAtPath(HistoryIndexer.indexFileName, HistoryIndexer) || {};
      content.articleSummaries = await repo.fetchContentAtPath(ArticlesIndexer.indexFileName, ArticlesIndexer) || {};
      content.cityGalleryImages = await repo.fetchContentAtPath(CityGalleryImageIndexer.indexFileName, CityGalleryImageIndexer) || {}
      content.article = params.slug ? await ArticleBySlug.get(repo, params.slug) || [] : [];
      content.homePage = await HomePage.get(repo)
      break;
  }
  return content;
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/loader.js